/**
 * Google Ads conversion tracking helpers.
 *
 * The global site tag (gtag.js) is loaded in `public/index.html` for
 * account AW-18361143948. Individual conversion events are fired
 * programmatically here rather than as static per-page snippets, because
 * this app is a single-page app where "success" doesn't always land on a
 * single dedicated URL (e.g. sign up can redirect to /profile, a specific
 * listing, or wherever the user came from).
 */

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
        dataLayer?: any[];
    }
}

/**
 * Fires the Google Ads "Sign up" conversion goal.
 * Conversion action: AW-18361143948/g7pMCIiAldwcEIylo7NE
 *
 * Call this exactly once per newly created account, right after a
 * registration call succeeds (email/password or Google OAuth without
 * requiring additional setup).
 */
export const trackSignupConversion = (): void => {
    try {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'conversion', {
                send_to: 'AW-18361143948/g7pMCIiAldwcEIylo7NE',
                value: 1.0,
                currency: 'USD',
            });
        }
    } catch (error) {
        // Never let analytics failures break the signup flow
        console.warn('Failed to fire Google Ads signup conversion event:', error);
    }
};
